module.exports = __webpack_public_path__ + "static/media/verification1.02fc1c86.png";